import clsx from "clsx";
import { Button } from "@/components";
import { Decimal, type DecimalString } from "@/lib/decimal";
import { useBalance } from "./balance/useBalance";
import styles from "./SimulatorPanel.module.css";

export interface SimulatorPanelProps {
  /** Grams still missing on the current line, for the "pour the rest" buttons. */
  remaining?: DecimalString | null;
  className?: string;
}

/** Pour controls for the simulated balance (shown only while the simulator is connected). */
export function SimulatorPanel({ remaining, className }: SimulatorPanelProps) {
  const balance = useBalance();
  const simulator = balance.simulator;
  if (balance.transport !== "simulator" || !simulator) return null;
  const missing = remaining ? Decimal.from(remaining).toNumber() : 0;

  return (
    <div className={clsx(styles.panel, className)} role="group" aria-label="Simulated balance">
      <span className={styles.title}>Simulator</span>
      <Button size="sm" disabled={missing <= 0} onClick={() => simulator.pourGrams(missing * 1.002, 900)}>
        Pour the rest
      </Button>
      <Button size="sm" disabled={missing <= 0} onClick={() => simulator.pourGrams(missing * 1.04 + 0.024, 900)}>
        Overshoot
      </Button>
      <Button size="sm" onClick={() => simulator.pourGrams(0.01, 300)}>
        +0.010 g
      </Button>
      <Button size="sm" onClick={() => simulator.pourGrams(0.1, 400)}>
        +0.100 g
      </Button>
      <Button size="sm" onClick={() => simulator.pourGrams(-0.01, 300)}>
        −0.010 g
      </Button>
      <Button size="sm" onClick={() => simulator.placeVessel(18.5)}>
        Place vessel
      </Button>
    </div>
  );
}
